import { render, staticRenderFns } from "./starpreview.vue?vue&type=template&id=46526849&"
import script from "./starpreview.vue?vue&type=script&lang=js&"
export * from "./starpreview.vue?vue&type=script&lang=js&"
import style0 from "./starpreview.vue?vue&type=style&index=0&id=46526849&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports